import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { trackCoPromoClick, trackCoPromosShow } from './tracking';
import { openPromoDetails } from '../../actions/promoDetails';
import { CoPromos } from '../../components/CoPromos';
import { NBSP } from '../../constants/symbols';
import { selectCoPromos } from '../../selectors/promosPage';
import { IPromo } from '../../types/promosPage';
import { createPromoProduct } from '../../utils/analytics';

const TITLE = `Такие скидки только у${NBSP}нас`;

export const CoPromosContainer: React.FC = () => {
  const coPromoList = useSelector(selectCoPromos);

  const dispatch = useDispatch();

  const handlePromoClick = React.useCallback(
    (promo: IPromo) => {
      dispatch(
        openPromoDetails({
          promo: promo.popup,
          product: createPromoProduct(promo),
        }),
      );
      trackCoPromoClick({ promo });
    },
    [dispatch],
  );

  if (!coPromoList.length) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackCoPromosShow}>
      <CoPromos title={TITLE} promoList={coPromoList} onPromoClick={handlePromoClick} />
    </ActionAfterViewObserver>
  );
};
